import { Options, Vue } from "vue-class-component";

@Options({})
export default class App extends Vue {}
